// extracted by mini-css-extract-plugin
export default {"card":"RedirectCard_card__eOuN3","fadeInUp":"RedirectCard_fadeInUp__O0Pi7","card_header":"RedirectCard_card_header__SjioI","redirect_link":"RedirectCard_redirect_link__Q9PYN"};